import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX } from '@/common/constants';

export const addUserSchema = (role: string) => {
    return (
        Yup.object({
            role: Yup.string()
                .trim()
                .required('Role is required'),
            type: Yup.string()
                .trim()
                .required('Type is required'),
            inspectingCompany: role === 'inspectingcompany' ? Yup.string()
                .trim()
                .required('Inspecting company is required') : Yup.string().nullable(),
            shipOperator: role === 'shipoperator' ? Yup.string()
                .trim()
                .required('Ship operator is required') : Yup.string().nullable(),
            email: Yup.string()
                .trim()
                .required('Email is required')
                .email('Enter a valid email address'),
            firstName: Yup.string()
                .trim()
                .required('First name is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            lastName: Yup.string()
                .trim()
                .required('Last name is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters')
        }));
}
